import script from "./TaoTeChing.vue?vue&type=script&setup=true&lang=js"
export * from "./TaoTeChing.vue?vue&type=script&setup=true&lang=js"

import "./TaoTeChing.vue?vue&type=style&index=0&id=4453d467&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4453d467"]])

export default __exports__